/**
 * Register the service worker only in production. In dev, CRA's HMR
 * sockets conflict with custom SWs.
 */
export function registerServiceWorker() {
    if (!("serviceWorker" in navigator)) return;
    if (process.env.NODE_ENV !== "production") return;
    window.addEventListener("load", () => {
        navigator.serviceWorker.register("/sw.js").catch((err) => {
            // ignore registration errors
            console.warn("SW registration failed", err);
        });
    });
}
